import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../../../environments/environment';
import { appModernizationDetails } from '../../../../../config';
import { Observable } from 'rxjs';
import { CommonService } from './common.service';
import { BULK_MAINTENANCE_ERROR_MESSAGES } from './bulk-maintenance-error-messages';

@Injectable({
    providedIn: 'root'
})

export class BusinessSupportService {
    private PADUStatus = ['Preferred', 'Acceptable', 'Discouraged', 'Unacceptable', 'Retired','Future', 'PADU Pending'];
    private PADUStatus_Add = [
    'Preferred',
    'Acceptable',
    'Discouraged',
    'Unacceptable',
    'Retired',
    'Future',
    'PADU Pending'
    ];
    private businessSupportRequiredHeaders = [
        'Update Type',
        'GLOBAL APP ID', 'LOB ID', 
        'Sub LOB ID', 'Organization ID' ,'Capability L0 Id', 'Group Model', 
        'Capability L1 Id', 'Capability L2 Id', 'Capability L3 Id',
        'Capability PADU', 'Capability PADU T1', 'Capability PADU T2',
        'Capability PADU T3', 'Capability PADU T4', 'Capability PADU T5', 
        'Capability PADU T6'
    ]
    private apiUrl: string;
    private largeApiUrl: string = environment.LargeapiUrl;
    private config: any;
    BULK_CAPP_MAPPING_UPDATE_TYPE = ['U', 'A', 'D'];
    largeOPsUrl: string;
    constructor(private commonService: CommonService, private http: HttpClient) {
        this.config = appModernizationDetails;
        this.apiUrl = environment.apiUrl;
        this.largeOPsUrl = environment.LargeapiUrl;
    }

    public getRequiredHeaders () {
      return this.businessSupportRequiredHeaders;
    }

    public transformIds (obj: any) {
      for (const key of Object.keys(obj)) {
        if (key == 'GLOBAL APP ID' || key == 'LOB ID' || 
        key == 'Sub LOB ID' || key == 'Organization ID' || key == 'Capability L0 Id'
        || key == 'Capability L1 Id' || key == 'Capability L2 Id' || key == 'Capability L3 Id') {
          const item = obj[key];
          if (item && item != 'No Mapping') {
            obj[key] = item.toUpperCase();
          }
        }
      }
      return obj;
    }

    public trimObjValues(obj: any) {
      Object.keys(obj).forEach(k => obj[k] = typeof obj[k] == 'string' ? obj[k].trim() : obj[k]); 
    }

    public transformPADU (ele: any) {
      const paduKeys = ['Capability PADU','Capability PADU T1','Capability PADU T2','Capability PADU T3','Capability PADU T4','Capability PADU T5','Capability PADU T6'];
      for (const key of paduKeys) {
        const val = ele[key];
        if (!val) continue;
        const match = this.PADUStatus.find(item => item.toLowerCase() === val.toLowerCase());
        if (match) ele[key] = match;
      }
    }

    public checkRequiredHeaders (headers: string[]) {
        const missingHeader = this.businessSupportRequiredHeaders.filter(item => !headers.includes(item));
        return missingHeader;
    }

    public validateRecordService(excelData: any[], isAdmin: boolean) {
      try{
      const captureAllError = [];
      let duplicateRecords = [];
  
     
      let validaterecords = [];
      const errorRecords = [];  
      const successRecords = [];
      const clonedExcelData = excelData.map(el => ({ ...el }));

      if (clonedExcelData && clonedExcelData.length > 0) {
          //Validate for Duplicate Records
        const uniqueKeyNames = this.commonService.capabilityMappingAllFields();
        const { uniques, duplicates } = this.commonService.findDuplicatesAndUniqueRecords(clonedExcelData, uniqueKeyNames); // { uniqueRecords, duplicates }
         duplicateRecords = duplicates;
        uniques.forEach((ele, index) => {
          this.trimObjValues(ele);
          ele = this.transformIds(ele);
          this.transformPADU(ele);
          const validatedRecord = this.ValidateBusinessMappingRecord(ele, index, isAdmin);
  
          validaterecords.push(validatedRecord);
          
        });
       
      }
      return  { validaterecords, duplicateRecords }; 
      }
      catch(err){
        console.log("Error in validateRecordService BusinessSupportService", err);
        return err;
      }
    }

   

  public ValidateBusinessMappingRecord(ele, index, isAdmin) {
    let requiredFields = [
      { key: 'Update Type', message: BULK_MAINTENANCE_ERROR_MESSAGES.BUSINESS_SUPPORT.UPDATE_TYPE_EMPTY, nullCheck: true },
      { key: 'Update Type', message: BULK_MAINTENANCE_ERROR_MESSAGES.BUSINESS_SUPPORT.UPDATE_TYPE_INVALID, validCheck: true },
      { key: 'GLOBAL APP ID', message: BULK_MAINTENANCE_ERROR_MESSAGES.BUSINESS_SUPPORT.GLOBAL_APP_ID_MISSING, nullCheck: true },
      { key: 'LOB ID', message: BULK_MAINTENANCE_ERROR_MESSAGES.BUSINESS_SUPPORT.LOB_ID_MISSING, nullCheck: true },
      { key: 'Sub LOB ID', message: BULK_MAINTENANCE_ERROR_MESSAGES.BUSINESS_SUPPORT.SUB_LOB_ID_MISSING, nullCheck: true },
    ];

    const updateType = ele['Update Type']?.trim();
    let obj = this.commonService.initializeValidationObject();
    obj = this.commonService.validateFieldsAndUpdateType(requiredFields, ele, index, obj, this.BULK_CAPP_MAPPING_UPDATE_TYPE);
    if (obj.status === false) {
      ele['Status'] = 'Fail';
      ele['Message'] = obj.message;
    } else {
      ele['Status'] = 'Success';
      ele['Message'] = '';
    }

    // Capability PADU validations (base + T1..T6)
    let EditableColumns = [
      { key: 'Capability PADU', Error: 'No Error', DBkey: 'current' },
      { key: 'Capability PADU T1', Error: 'No Error', DBkey: 'transition_1' },
      { key: 'Capability PADU T2', Error: 'No Error', DBkey: 'transition_2' },
      { key: 'Capability PADU T3', Error: 'No Error', DBkey: 'transition_3' },
      { key: 'Capability PADU T4', Error: 'No Error', DBkey: 'transition_4', },
      { key: 'Capability PADU T5', Error: 'No Error', DBkey: 'transition_5' },
      { key: 'Capability PADU T6', Error: 'No Error', DBkey: 'transition_6' },
    ];
    ele['EditableColumns'] = EditableColumns;

    const paduCapabilityKeys = ['Capability PADU', 'Capability PADU T1', 'Capability PADU T2', 'Capability PADU T3', 'Capability PADU T4', 'Capability PADU T5', 'Capability PADU T6'];
    for (const key of paduCapabilityKeys) {
      const value = ele[key]?.trim();
      if (this.CheckValidPADUStatus(value, updateType)) {
        this.elementErrorMessage(ele, key);
      }
      if (this.checkPaduPending(isAdmin, value, updateType)) {
        this.elementErrorMessage(ele, key);
      }
    }
    return ele;
  }

  elementErrorMessage(ele, key) {
    ele['EditableColumns'].forEach(col => {
      if (col.key === key) {
        col.Error = BULK_MAINTENANCE_ERROR_MESSAGES.BUSINESS_SUPPORT.INVALID_PADU_COLUMN_VALUE(col.key);
      }
    });
    this.commonService.appendError(
      ele,
      BULK_MAINTENANCE_ERROR_MESSAGES.BUSINESS_SUPPORT.INVALID_PADU_MESSAGE(key)
    );
  }

    public CheckValidPADUStatus (e: string, actiontype: string) {
      if (!e) e = 'PADU Pending';
      if (actiontype === 'A') {
        return this.PADUStatus_Add.indexOf(e) < 0;
      }
      if (actiontype === 'U') {
        return this.PADUStatus.indexOf(e) < 0;
      }
      return false; // default when action type not matched
    }

    public capabilityMappingPreview(body: any): Observable<any> {
        const url = this.largeOPsUrl + this.config.routerpath.businessSupportBulkPreview;
        const headers = new HttpHeaders({
          'Content-Type': ''
        });
        const options = {
          headers: headers
        }
        return this.http.put<any>(url, body, options);
    }

    public submitBusinessMapping (body: any): Observable<any> {
        const url = this.largeOPsUrl + this.config.routerpath.businessSupportBulkSubmit;
        const headers = new HttpHeaders({
          'Content-Type': ''
        });
        const options = {
          headers: headers
        }
        return this.http.put<any>(url, body, options);
    }

    public checkPaduPending(isAdmin: boolean, padu: string, updateType: string) {
      if (!padu || !updateType) return false;
      return !isAdmin && updateType.toLowerCase() === 'a' && padu.toLowerCase() === 'padu pending';
    }

   
}